module.exports = __webpack_public_path__ + "static/atlas_of_endless_horizons-51e14cc4e2f93e8c637c9bb5c4737017.png";